import applyapis from "../../api/score.js";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";
 
export default {
    name: "BankBossAudit",
    props: {
        visible: {
            type: Boolean,
            require: false
        },
        propsOne: String
    },
    data() {
        return {
            activeName: 'first',
            scrollHeight: 400,
            query: {
                userName: "",
            },
            isVisible: this.visible,
            detailResult: {},
            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,

            flowInfo: {
                ApplyID:'',
                UserId:'',
                Phone:'',
                PersonCompanyText:'',
                PersonCompanyFlag:'',
                PersonCompanyKey:'',
                LoanTipsId:'',
                Money:'',
                CreateTime:'',
                BankID:'',
                BankSiteID:'',
                SiteDirectorID:'',
                FirstBusiness:'',
                SecondBusiness:'',
                PeopleCount:'',
                LastYearIncome:'',
                LastYearTax:'',
                LastYearProfit:'',
                FinalMoney:null,
                EntrustedGuarantee:null,
                LoanYear:null,
                LoanTime:null,
            },
            fileList: [],
            fileList_FJ: [],
            picList: [],
            flowLogs:[],
            reasonVisible: false,
            queryTime: dateUtils.dateToStr("yyyy-MM-dd hh:mm:00", new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            stepsStatus: 2,
            errorflag: false,
            secondBusinessTitle:'二级业务',
            loanApply:{
               
            },
            loanAudit: {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                hknl_value3:null,
                CreditRating:null,
                TotalAssets:null,
                AssetCoverage:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeId:null,
                Area:null,
                GuaranteeRate:null,
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
            },
            scorelist:[0,0,0,0,0,0],
            zxbglist:[],
            loanMortgage: [],
            loanCredit: {
                Id: null,
                keyword: null,
                num: null,
                createTime: null,
                danwei: null,
                money: null,
                comment2: null,
                comment2_gm: null,
                comment2_xy: null,
                comment2_js: null,
                comment: null,
                comment_xy: null,
                comment_gm: null,
                comment_js: null
            },
            loanCreditArea: {
                Id: null,
                keyword: null,
                name: null,
                area: null,
            },
            llTableData:[],
            contractObj:null,
            bankInfoObj:{},
            xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
        areascorelist:["","",""],
        auditShow:false,
            rules: {
                FinalMoney:[
                    { required: true, message: '请填写最终贷款金额', trigger: 'change' },
                    { type: 'integer', message: '最终贷款金额必须为数值', trigger: 'change'},
                ],
                LoanYear: [
                  { required: true, message: '请填写担保函年份', trigger: 'change' },
                ],
                LoanTime:[
                    { required: true, message: '请填写担保函序号', trigger: 'change' },
                ],
                EntrustedGuarantee: [
                    { required: true, message: '请填写委托担保合同号', trigger: 'change' }
                ],
            }
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if (meta && meta.permBtns.length > 0) {
            this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
        onChangeClose() {
            this.isVisible = false
        },
        onChangeOpen() {
            this.isVisible = true
        },
        queryData(row,type) {
            this.llTableData=[]
            this.loanAudit={}
            this.areascorelist=["","",""]
            let that = this
            if(type=="update"){this.auditShow=true;this.activeName="second"}
            else {this.auditShow=false;this.activeName="first";}
            if (row) {
                applyapis.getapplyOnlineById({Id: row.ApplyID}).then((res) => {
                    that.flowInfo = res;
                    if(that.flowInfo&&that.flowInfo.FinalMoney){
                        that.flowInfo.FinalMoney = utils.deepCopy(that.flowInfo.FinalMoney)*1.0/1000000
                    }
                    if(that.flowInfo.FrontImg){
                        that.flowInfo.FrontImg=PLATFROM_CONFIG.baseUrl+"/fileUploadData/"+that.flowInfo.FrontImg
                        that.flowInfo.BackImg=PLATFROM_CONFIG.baseUrl+"/fileUploadData/"+that.flowInfo.BackImg
                        that.flowInfo.PersonImg=PLATFROM_CONFIG.baseUrl+"/fileUploadData/"+that.flowInfo.PersonImg
                    }
                    if (res.State == 3||res.State == 5) {
                        that.errorflag = true;
                    }else{
                        that.errorflag = false;
                    }
                    if(res.areaList&&res.areaList.length>0){
                        that.llTableData=res.areaList;
                            var age=that.getAge(that.flowInfo.IdNum);
                            that.areascorelist[0]=age;
                            if(age>17&&age<60){
                              var n=0;
                            for(var i=0;i<that.llTableData.length;i++){
                             n+=Number(that.llTableData[i].area)
                            }
                            if(n==0)that.areascorelist[2]=5;
                            else if(n>=20)that.areascorelist[2]=20;
                            else if(n>=10)that.areascorelist[2]=10;
                            else that.areascorelist[2]=8;
                            that.areascorelist[1]=n;
                            }


                    }
                    if(res.scoreobj)that.loanAudit=res.scoreobj;

                    let status = Number(that.flowInfo.Status)
                    this.changeSecondBusinessShow(that.flowInfo.FirstBusiness)
                        switch (status) {
                            case 1:
                                that.stepsStatus = 1
                                break;
                            case 2:
                                that.stepsStatus = 2
                                break;
                            case 3:
                                that.stepsStatus = 2
                                break;
                            case 4:
                                that.stepsStatus = 3
                                break;
                            case 5:
                                that.stepsStatus = 3
                                break;
                        }
                })
            }
        },
        getAge(idCard) {
            const birthday = idCard.match(/\d{6}(\d{4})(\d{2})(\d{2})/);
          if (birthday) {
          const year = parseInt(birthday[1]);
          const month = parseInt(birthday[2]);
          const day = parseInt(birthday[3]);
           const today = new Date();
             let age = today.getFullYear() - year;
           if (today.getMonth() < month - 1 || (today.getMonth() == month - 1 && today.getDate() < day)) {
                 age--;
                }
          return age;
         } else {
           return -1; // 身份证号不合法
      }
     },
        beforeAvatarPicUpload(file) {
            let that = this
            const isJPG =
                file.type === "image/jpg" ||
                file.type === "image/jpeg" ||
                file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                that.$message.error("仅支持jpg、png格式的图片")
            }
            if (!isLt2M) {
                that.$message.error("上传图片大小不能超过2MB")
            }
            return isJPG && isLt2M
        },
        uploadPicFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.picList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        beforeAvatarFileUpload(file) {
            let that = this
            const isLt2M = file.size / 1024 / 1024 < 10
            if (!isLt2M) {
                that.$message.error("上传文件大小不能超过10MB")
            }
            return true
        },
        uploadFileFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.fileList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        getFileName(path) {
            var pos1 = path.lastIndexOf('/');
            var pos2 = path.lastIndexOf('\\');
            var pos = Math.max(pos1, pos2)
            if (pos < 0)
                return path;
            else
                return path.substring(pos + 1);
        },
        handlePicRemove(file) {
            let that = this
            if (file) {
                for (let i = 0; i < that.picList.length; i++) {
                    if (file.url === that.picList[i].url) {
                        that.picList.splice(i, 1)
                    }
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePicDownload(file) {
            if (file) {
                const blob = new Blob([file.url], {type: 'application/vnd.ms-excel'})
                const elink = document.createElement('a')
                elink.download = file.name
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
            }
        },
        /**
         * 银行拒绝通过
         */
        onReturnFlow() {
            let that = this
            this.$prompt('', '必须填写拒绝的原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputErrorMessage: '必须填写原因',
                inputValidator: (value) => {
                    if (value.trim().length < 1) {
                        return false
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action == 'confirm') {
                        let value = instance.inputValue
                        if (value && value != '') {
                            let param = {
                                ApplyID: that.flowInfo.ApplyID,
                                RefuseReason: value,
                                State: '5',
                            }
                            applyapis.updateOnlineApply(param).then((res) => {
                                if (res) {
                                    done()
                                } else {
                                    that.$message({
                                        message: res.msg,
                                        type: "error"
                                    });
                                }
                            })
                        }
                    } else {
                        done()
                    }
                }
            }).then(({value}) => {
                that.onChangeClose()
                that.$parent.bankAuditSucess();
            }).catch(() => {

            });
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height = height1 - 150 - 20;
                this.scrollHeight = height;
            });
        },
        
      /**
       * 审核通过
       */
      onPassFlow(){
        let that = this
        var flowInfo={
            ApplyID:that.flowInfo.ApplyID,
            State:4,
          }
          applyapis.updateOnlineApply(flowInfo).then((res) => {
            if(res){
              that.onChangeClose()
              that.$parent.bankAuditSucess();
            }else{
                that.$message({
                message: res.msg,
                type: "error"
              });
            }
          })
      },
        /**
         * 银行通过
         */
        toViewUrl(type) {
            if (type == 1) {
                window.open(this.flowInfo.ViewUrl)
                if (this.flowInfo.cpViewUrl) window.open(this.flowInfo.cpViewUrl)
            } else {
                window.open(this.flowInfo.DownLoadUrl)
                if (this.flowInfo.cpDownLaodUrl) window.open(this.flowInfo.cpDownLaodUrl)
            }
        },
        changeSecondBusinessShow(value) {
            switch (value) {
                case '电商':
                    this.secondBusinessTitle = '销售类目'
                    break;
                case '种植':
                    this.secondBusinessTitle = '种植作物'
                    break;
                case '养殖':
                    this.secondBusinessTitle = '养殖种类'
                    break;
                case '农产品加工':
                    this.secondBusinessTitle = '加工品类'
                    break;
                case '农资农机销售':
                    this.secondBusinessTitle = '销售品类'
                    break;
                case '农产品购销':
                    this.secondBusinessTitle = '产品类型'
                    break;
                case '农业服务':
                    this.secondBusinessTitle = '服务项目'
                    break;
                case '农业旅游农家乐':
                    this.secondBusinessTitle = '产业类型'
                    break;
                case '农业相关工程':
                    this.secondBusinessTitle = '工程内容'
                    break;
                case '其他':
                    this.secondBusinessTitle = '经营项目'
                    break;
            }
        },
        onDownChange(path){
          window.open(path)
        }
    },
};
